export default async function ({ route, error, store, $axios }) {
  if (!process.server) {
    return
  }

  const slug = route.params.slug
  const query = route.query

  if (!slug) {
    return error({ statusCode: 404, message: 'Product not found' })
  }

  try {
    const result = await store.dispatch('product/fetchProduct', {
      slug,
      query,
    })
    if (!result) {
      return error({ statusCode: 404, message: 'Product not found' })
    }
  } catch (error) {
    return error({ statusCode: 404, message: 'Product not found' })
  }
}
